import { useEffect, useRef } from "react";

export default function CursorSound({ soundSrc = "/hover.mp3", enabled = true }) {
  const audioRef = useRef(null);
  const lastCursor = useRef("");

  useEffect(() => {
    const audio = new Audio(soundSrc);
    audio.volume = 0.5; // 50% volume
    audioRef.current = audio;
  }, [soundSrc]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!enabled || !audioRef.current) return;
      
      const cursor = window.getComputedStyle(e.target).cursor;
      if (cursor === "pointer" && lastCursor.current !== "pointer") {
        audioRef.current.currentTime = 0;
        audioRef.current.volume = 0.5;
        audioRef.current.play().catch(err => {
          // Silently catch autoplay errors
          console.debug("Audio play prevented:", err);
        });
      }
      lastCursor.current = cursor;
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [enabled]);

  return null;
}
